import { render, staticRenderFns } from "./Ascencions.vue?vue&type=template&id=03eed093&scoped=true&"
import script from "./Ascencions.vue?vue&type=script&lang=js&"
export * from "./Ascencions.vue?vue&type=script&lang=js&"
import style0 from "./Ascencions.vue?vue&type=style&index=0&id=03eed093&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eed093",
  null
  
)

export default component.exports